<template>
  <div class="d-flex flex-column justify-space-between align-center">
    <span class="primary--text text-h4" :data-count="count">{{ count }}</span>
    <v-rating
      dense
      empty-icon="fas fa-star"
      full-icon="fas fa-star"
      half-icon="fas fa-star-half"
      background-color="#C4C4C4"
      color="#F2C94C"
      length="5"
      size="15"
      :ripple="false"
      half-increments
      :value="roundNumber(count, 0.5, 'ceil')"
      :readonly="readonly"
    ></v-rating>
  </div>
</template>
<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
};
</script>
